import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import * as i0 from "@angular/core";
const defaultTranslations = {
    'ngx-shared-due-to-inactivity': 'Due to inactivity,',
    'ngx-shared-minute': 'minute',
    'ngx-shared-minutes': 'minutes',
    'ngx-shared-remaining': 'remaining',
    'ngx-shared-second': 'second',
    'ngx-shared-seconds': 'seconds',
    'ngx-shared-you-have-been-logged-out': 'you have been logged out.',
    'ngx-shared-you-will-be-logged-out-automatically': 'you will be logged out automatically.',
    'ngx-shared-your-session-will-expire-in': 'Your session will expire in',
    'ngx-shared-close-dialog': 'close',
    'ngx-shared-close-this-alert': 'Close this alert',
    'ngx-shared-important': 'Important',
    'ngx-shared-success': 'Success',
    'ngx-shared-warning': 'Warning',
    'ngx-shared-error': 'Error',
    'ngx-shared-menu-option': 'menu option',
    'ngx-shared-options': 'Options',
    'ngx-shared-search': 'Search',
    'ngx-shared-select-all': 'Select all',
    'ngx-shared-selected': 'selected',
    'ngx-shared-content-is-loading': 'Content is loading',
    'ngx-shared-please-wait-the-page-is-loading': 'Please wait, the page is loading.',
    'ngx-shared-of': 'of',
    'ngx-shared-off': 'off',
    'ngx-shared-on': 'on',
    'ngx-shared-switch': 'switch',
    'ngx-shared-instructions-toggle-tip': 'instructions toggle tip button',
    'ngx-shared-open-calendar': 'Open Calendar',
    'ngx-shared-page': 'Page',
    'ngx-shared-showing': 'Showing',
    'ngx-shared-results': 'results',
    'ngx-shared-page-changed': 'Page changed',
    'ngx-shared-to': 'to',
    'ngx-shared-pager-ellipsis': 'horizontal ellipses',
};
export class TranslateAdapter {
}
export class DefaultTranslateAdapter extends TranslateAdapter {
    constructor() {
        super(...arguments);
        this.language = 'en-us';
    }
    translate(key, context, language) {
        const checkIfKeyExistsinDefaults = Object.keys(defaultTranslations).find((k) => k === key);
        if (!!checkIfKeyExistsinDefaults) {
            return new BehaviorSubject(defaultTranslations[key]);
        }
        return new BehaviorSubject(key);
    }
}
DefaultTranslateAdapter.ɵfac = /*@__PURE__*/ function () { let ɵDefaultTranslateAdapter_BaseFactory; return function DefaultTranslateAdapter_Factory(t) { return (ɵDefaultTranslateAdapter_BaseFactory || (ɵDefaultTranslateAdapter_BaseFactory = i0.ɵɵgetInheritedFactory(DefaultTranslateAdapter)))(t || DefaultTranslateAdapter); }; }();
DefaultTranslateAdapter.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DefaultTranslateAdapter, factory: DefaultTranslateAdapter.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DefaultTranslateAdapter, [{
        type: Injectable
    }], null, null); })();
export class TranslateService {
    constructor(translateAdapter) {
        this.translateAdapter = translateAdapter;
    }
    get language() {
        return this.translateAdapter.language;
    }
    translate(key, context) {
        try {
            return this.translateAdapter.translate(key, context, this.language);
        }
        catch (err) {
            console.warn(`language: ${this.language}, key: ${key}, args:${JSON.stringify(context)}`);
            console.warn(err);
            return of(undefined);
        }
    }
}
TranslateService.ɵfac = function TranslateService_Factory(t) { return new (t || TranslateService)(i0.ɵɵinject(TranslateAdapter)); };
TranslateService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TranslateService, factory: TranslateService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslateService, [{
        type: Injectable
    }], function () { return [{ type: TranslateAdapter }]; }, null); })();
